export const getPrices = state => state.prices
